/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomefieldStrikethroughPriceComponent } from './strikethrough-price.component';

@NgModule({
	imports: [CommonModule],
	declarations: [HomefieldStrikethroughPriceComponent],
	exports: [HomefieldStrikethroughPriceComponent]
})
export class HomefieldStrikethroughPriceModule {}
